import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';

import { ConfigVersionDetail, configRegistryKeys } from './useConfigsQuery';

/**
 * One historical version, with its payload.
 *
 * Fetched only when an entry is expanded. History is append-only, so a version
 * that has loaded once can never change — hence the infinite staleTime.
 */
export const useConfigVersionQuery = (key: string | null, version: number | null) => {
  const { sessionState } = useAuth();
  const isReady = isSignedIn(sessionState);

  return useQuery({
    queryKey: configRegistryKeys.version(key ?? '', version ?? 0),
    queryFn: async () => {
      const { data } = await get<ConfigVersionDetail>(
        `/v1.0/internals/configs/${encodeURIComponent(key as string)}/versions/${version}`,
      );
      return data;
    },
    enabled: isReady && !!key && version != null,
    staleTime: Infinity,
  });
};

export default useConfigVersionQuery;
